import { IconButton, Box } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { SIDEBAR_CONFIG } from "Constants/SidebarConfig";

interface SidebarToggleButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const SidebarToggleButton = ({ isCollapsed, onToggle }: SidebarToggleButtonProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        right: -16,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1200,
      }}
    >
      <IconButton
        onClick={onToggle}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        sx={{
          width: SIDEBAR_CONFIG.toggleButtonSize,
          height: SIDEBAR_CONFIG.toggleButtonSize,
          padding: `${SIDEBAR_CONFIG.toggleButtonPadding}px`,
          bgcolor: "primary.main",
          color: "white",
          border: "2px solid #fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
          "&:hover": {
            bgcolor: "primary.dark",
            transform: "scale(1.1)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          },
          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        {isCollapsed ? (
          <ChevronRight 
            sx={{ 
              fontSize: 18,
              transition: `transform ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
            }} 
          />
        ) : (
          <ChevronLeft 
            sx={{ 
              fontSize: 18,
              transition: `transform ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
            }} 
          />
        )}
      </IconButton>
    </Box>
  );
};

export default SidebarToggleButton;